import DOMPurify from 'dompurify';

import { GetDisclosuresResponseType, ServerResponseType } from './types';

export const transformDisclosuresResponse = (
  response: ServerResponseType
): GetDisclosuresResponseType => {
  return {
    completed: response.completed,
    bodyTextSanitized: {
      __html: DOMPurify.sanitize(response.bodyText),
    },
    dueDate: response.dueDate,
  };
};

export const transformDisclosuresResponseWithConfig = (
  response: ServerResponseType,
  config: DOMPurify.Config
): GetDisclosuresResponseType => {
  return {
    completed: response.completed,
    bodyTextSanitized: {
      __html: DOMPurify.sanitize(response.bodyText, config) as string,
    },
    dueDate: response.dueDate,
  };
};
